/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { CustomTextDocumentMetadata } from 'src/customText/core/stores/CustomTextDocumentStore';
import { ModelJobStates } from 'src/modules/modelTraining/types/trainingTypes';

export enum AutoLabelingSteps {
    AutoLabelingJob = 0,
    ConfigureJob = 1,
    SelectEntitiesOrClasses = 2,
    SelectFiles = 3,
    ReviewAndFinish = 4
}

export type AutoLabelingJobType = 'gpt' | 'trainedModel';

export type AutoLabelingInfoDto = {
    selectedChars: number;
    classesNames: string[];
    entitiesNames: string[];
    trainedModelLabel?: string;
    azureOpenAiDeploymentName: string;
    azureOpenAiResourceRegion: string;
    documents: CustomTextDocumentMetadata[];
    autoLabelingJobType: AutoLabelingJobType;
};

export type AutoLabelingScreenProps<T> = {
    onDismiss: () => void;
    onPrevious?: () => void;
    onSubmit: (data: T) => void;
    autoLabelingInfoDto: AutoLabelingInfoDto;
};

export type AzureOpenAiDeployment = { id: string; deploymentName: string };

export type AutoTaggingJobItem = {
    id: string;
    elapsedTime: string;
    percentage?: number;
    createdDateTime: Date;
    status: ModelJobStates;
    expirationDateTime: Date;
    trainedModelLabel?: string;
};
